module.exports = __webpack_public_path__ + "img/beispiel.14f8d245.svg";